(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-floral"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Animate heading
  const heading = document.querySelector('.faq-floral-section h2');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        heading.classList.add('visible');
      }
    });
  }, { threshold: 0.3 });
  observer.observe(heading);

  // FAQ toggle
  const items = document.querySelectorAll('.faq-floral-section .faq-item');
  items.forEach(item => {
    const q = item.querySelector('.faq-question');
    q.addEventListener('click', () => {
      item.classList.toggle('open');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty_earn_points"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const sectionHeading = document.querySelector('.loyalty-section h2');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        sectionHeading.classList.add('visible');
      }
    });
  }, { threshold: 0.3 });
  observer.observe(sectionHeading);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redeem-petals"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Heading animation
  const sectionHeading = document.querySelector('.redeem-section h2');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        sectionHeading.classList.add('visible');
      }
    });
  }, { threshold: 0.3 });
  observer.observe(sectionHeading);
});

  } catch(e) { console.error(e); }
})();
})();
